<template>
  <div class="recentTimePage">
    <div class="recentContent flex-center">
      <div class="recentContent-item" :class="[index == currentIndex && 'active']" v-for="item, index in recentList" :key="item.value" @click="selectType(item, index)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recentList: {
      type: Array,
      default: () => [
        {
          label: '近30天',
          value: 30,
          type: 'day',
        },
        {
          label: '近90天',
          value: 90,
          type: 'day',
        },
        {
          label: '近180天',
          value: 180,
          type: 'day',
        },
        {
          label: '近1年',
          value: 365,
          type: 'day',
        }
      ],
    },
    defaultIndex: {
      type: [Number,String],
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0,
    } 
  },
  watch: {
    defaultIndex: {
      handler(newVal, oldVal) {
        this.currentIndex = newVal;
      },
      immediate: true,
    }
  },
  methods: {
    selectType(item, index) {
      this.currentIndex = index;
      this.$emit('change', item.value,index);
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
:deep(.recent-time) {
  width: 240px;
  margin-left: 8px;
}
.recentContent {
  &-item {
    background: #fff;
    border: 1px solid #efefef;
    padding: 5px 11px;
    color: #666;
    border-radius: 4px;
    min-width: 60px;
    text-align: center;
    letter-spacing: .2px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-weight: 400;
    line-height: 1.5715;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
    transition: all .1s cubic-bezier(0,0,1,1);
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
    font-size: 12px;
  }
  &-item:hover {
   opacity: 0.8; 
  }
  &-item:not(:first-child) {
    margin-left: 8px;
  }
  &-item:last-child {
    margin-right: 8px;
  }
  .active {
    background: #fff !important;
    border: 1px solid #3159FF !important;
    padding: 5px 11px !important;
    color: #3159FF !important;
    opacity: 1 !important;
  }
}
</style>